var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 105,
    viewBox: "0 0 94 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1301 31.0901C41.0624 31.2574 41.0443 31.4406 41.078 31.618C41.1117 31.7953 41.1957 31.9592 41.3201 32.0901L44.2101 34.98C44.3823 35.1525 44.479 35.3863 44.479 35.6301C44.479 35.8738 44.3823 36.1076 44.2101 36.2801L36.3201 44.17C36.1476 44.3422 35.9138 44.439 35.67 44.439C35.4263 44.439 35.1926 44.3422 35.0201 44.17L32.3301 41.5001C32.1909 41.3725 32.0183 41.2869 31.8325 41.2533C31.6467 41.2197 31.4552 41.2394 31.2801 41.3101L31.0701 41.41C30.9016 41.4793 30.7574 41.5971 30.6559 41.7485C30.5545 41.8998 30.5002 42.0779 30.5001 42.2601V46.05C30.5014 46.1725 30.4783 46.2941 30.432 46.4075C30.3857 46.521 30.3173 46.624 30.2306 46.7106C30.144 46.7973 30.041 46.8657 29.9275 46.912C29.8141 46.9582 29.6926 46.9814 29.5701 46.98H18.43C18.3075 46.9814 18.186 46.9582 18.0726 46.912C17.9591 46.8657 17.8561 46.7973 17.7695 46.7106C17.6828 46.624 17.6144 46.521 17.5681 46.4075C17.5218 46.2941 17.4987 46.1725 17.5001 46.05V42.66C17.5001 42.4685 17.4404 42.2818 17.3293 42.1258C17.2181 41.9699 17.0611 41.8525 16.8801 41.79L16.3901 41.6C16.2232 41.5298 16.0393 41.5104 15.8614 41.5442C15.6835 41.578 15.5196 41.6635 15.3901 41.79L12.99 44.1901C12.8176 44.3623 12.5838 44.459 12.3401 44.459C12.0963 44.459 11.8625 44.3623 11.6901 44.1901L3.80004 36.3C3.62784 36.1276 3.53112 35.8938 3.53112 35.6501C3.53112 35.4063 3.62784 35.1725 3.80004 35.0001L6.00005 32.8C6.12382 32.6688 6.20674 32.5044 6.2387 32.3268C6.27066 32.1493 6.25027 31.9662 6.18005 31.8C6.07005 31.57 5.97006 31.33 5.88006 31.1C5.81372 30.9211 5.69337 30.7673 5.5357 30.6598C5.37803 30.5523 5.19085 30.4964 5.00005 30.5001H1.92004C1.79754 30.5014 1.67599 30.4783 1.56255 30.432C1.44912 30.3857 1.34608 30.3173 1.25945 30.2306C1.17283 30.144 1.10436 30.041 1.0581 29.9275C1.01184 29.8141 0.988706 29.6926 0.990045 29.5701V18.43C0.988706 18.3075 1.01184 18.186 1.0581 18.0726C1.10436 17.9591 1.17283 17.8561 1.25945 17.7695C1.34608 17.6828 1.44912 17.6144 1.56255 17.5681C1.67599 17.5218 1.79754 17.4987 1.92004 17.5001H5.00005C5.18627 17.5003 5.36817 17.444 5.52172 17.3387C5.67528 17.2333 5.79325 17.0839 5.86004 16.91C5.95004 16.68 6.05003 16.4401 6.16003 16.2101C6.23025 16.0439 6.25064 15.8608 6.21868 15.6833C6.18672 15.5057 6.1038 15.3413 5.98004 15.2101L3.78008 13.0101C3.60788 12.8376 3.5111 12.6038 3.5111 12.36C3.5111 12.1163 3.60788 11.8826 3.78008 11.7101L11.67 3.82006C11.8425 3.64786 12.0763 3.55114 12.3201 3.55114C12.5638 3.55114 12.7975 3.64786 12.97 3.82006L15.3701 6.22003C15.4995 6.34659 15.6635 6.43214 15.8414 6.46594C16.0192 6.49973 16.2032 6.48028 16.3701 6.41003L16.86 6.22003C17.0411 6.15758 17.1981 6.04023 17.3093 5.88427C17.4204 5.72832 17.4801 5.54154 17.48 5.35003V1.96008C17.4787 1.83758 17.5018 1.71603 17.5481 1.60259C17.5944 1.48916 17.6628 1.38606 17.7494 1.29943C17.8361 1.21281 17.9392 1.1444 18.0526 1.09814C18.166 1.05188 18.2875 1.02875 18.41 1.03008H29.55C29.6725 1.02875 29.7941 1.05188 29.9075 1.09814C30.021 1.1444 30.124 1.21281 30.2106 1.29943C30.2973 1.38606 30.3657 1.48916 30.412 1.60259C30.4582 1.71603 30.4814 1.83758 30.48 1.96008V5.75005C30.4802 5.93225 30.5345 6.11033 30.636 6.26165C30.7375 6.41298 30.8815 6.53072 31.05 6.60003L31.2601 6.70007C31.4352 6.77077 31.6267 6.79045 31.8125 6.75683C31.9983 6.72321 32.1708 6.63764 32.3101 6.51006L35.0001 3.82006C35.1725 3.64786 35.4063 3.55114 35.6501 3.55114C35.8938 3.55114 36.1276 3.64786 36.3 3.82006L44.1901 11.7101C44.3623 11.8826 44.459 12.1163 44.459 12.36C44.459 12.6038 44.3623 12.8376 44.1901 13.0101L41.3 15.9001C41.1757 16.0309 41.0917 16.1948 41.058 16.3721C41.0243 16.5495 41.0424 16.7327 41.11 16.9001V16.9001C41.178 17.0731 41.2963 17.2218 41.4496 17.327C41.6029 17.4321 41.7841 17.4889 41.97 17.49H46.05C46.1725 17.4887 46.2941 17.5118 46.4075 17.5581C46.521 17.6044 46.624 17.6728 46.7106 17.7595C46.7973 17.8461 46.8657 17.9491 46.912 18.0626C46.9582 18.176 46.9814 18.2975 46.98 18.42V29.5601C46.9814 29.6826 46.9582 29.8041 46.912 29.9175C46.8657 30.031 46.7973 30.134 46.7106 30.2206C46.624 30.3073 46.521 30.3757 46.4075 30.422C46.2941 30.4683 46.1725 30.4914 46.05 30.49H42.0001C41.8113 30.4899 41.627 30.5473 41.4715 30.6545C41.3161 30.7616 41.197 30.9136 41.1301 31.0901V31.0901Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.41 50.83C75.8647 44.0672 72.7933 37.7576 67.8069 33.1566C62.8206 28.5557 56.2847 26.0007 49.5 26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3899 43.16L81.7499 42.01L76.0999 50.09L68.4499 43.87L67.1899 45.42L76.4999 53L83.3899 43.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5901 55.1699C23.1354 61.9327 26.2067 68.2424 31.1931 72.8433C36.1795 77.4443 42.7153 79.9993 49.5001 79.9999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6101 62.84L17.2501 63.99L22.9001 55.91L30.5501 62.13L31.8201 60.58L22.5001 53L15.6101 62.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 35C29.5751 35 34.5 30.0751 34.5 24C34.5 17.9249 29.5751 13 23.5 13C17.4249 13 12.5 17.9249 12.5 24C12.5 30.0751 17.4249 35 23.5 35Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3701 72.7801C92.7386 75.9157 92.32 79.0938 91.1519 82.027C89.9839 84.9602 88.1033 87.5561 85.6801 89.5801C85.3104 89.8855 85.0129 90.2689 84.8089 90.7029C84.6049 91.1368 84.4995 91.6106 84.5001 92.0901V97.0001H62.5001V92.0901C62.5027 91.6113 62.3991 91.1377 62.1968 90.7037C61.9945 90.2697 61.6985 89.886 61.3301 89.5801C58.9376 87.5971 57.0679 85.0575 55.885 82.1839C54.7021 79.3103 54.2421 76.1904 54.5452 73.0977C54.8484 70.005 55.9056 67.0339 57.624 64.4447C59.3424 61.8555 61.6696 59.7274 64.4017 58.2468C67.1339 56.7661 70.1874 55.9782 73.2949 55.9521C76.4023 55.926 79.4687 56.6624 82.2253 58.0969C84.982 59.5314 87.3446 61.6201 89.1063 64.1801C90.868 66.74 91.975 69.6929 92.3301 72.7801H92.3701Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 97H84.5V102.15C84.5 102.641 84.3051 103.111 83.9581 103.458C83.6112 103.805 83.1407 104 82.65 104H64.35C63.8593 104 63.3888 103.805 63.0419 103.458C62.6949 103.111 62.5 102.641 62.5 102.15V97V97Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 97H87.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 68.16V62.98",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 86.16V80.98",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9099 74.5701H85.0899",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9099 74.5701H67.0899",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.03 79.1001L80.5 82.0001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 68L68.97 70.04",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.97 79.1001L66.5 82.0001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 68L78.03 70.04",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.5,
    height: 105,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.5cdae4a146b32214f2e73e709f26b74b.svg";
export { ForwardRef as ReactComponent };